// extracted by mini-css-extract-plugin
export var logo = "_jc-2";
export var logoWrapper = "_jc-1";
export var strip = "_jc-0";